import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

// Define our single API slice object
export const MoralisApiSlice = createApi({
  // The cache reducer expects to be added at `state.api` (already default - this is optional)
  reducerPath: 'moralisapi',
  // All of our requests will have URLs starting with '/fakeApi'
  baseQuery: fetchBaseQuery({
    baseUrl: 'https://deep-index.moralis.io/api/v2',
    prepareHeaders: (headers, { getState }) => {
      headers.set('accept', 'application/json');
      headers.set('Access-Control-Allow-Origin', '*');
      headers.set('X-API-Key', 'MFrQgJTNsS5qyeDGm1pbhPF3VWmU4eXBqrNYleYUMUzgs6pNpFpwGOylPNE6TmgI');
      return headers;
    },
  }),
  // The "endpoints" represent operations and requests for this server
  endpoints: (builder) => ({
    // The `getPosts` endpoint is a "query" operation that returns data
    getPriceToken: builder.query({
      // The URL for the request is '/fakeApi/posts'
      query: (token) => `/erc20/${token}/price?chain=bsc`,
    }),
  }),
});

// Export the auto-generated hook for the `getPosts` query endpoint
export const { useGetPriceTokenQuery } = MoralisApiSlice;
